import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    readOnly: PropTypes.bool,
    isRequired: PropTypes.bool,
};

const TextAreaField = ({
    input,
    label,
    type,
    value,
    readOnly,
    isRequired,
    meta: { touched, error, warning },
    isFocus,
    ...custome
}) => {
    return (
        <>
            {label ? (
                <label htmlFor="inputfname" className="control-label">
                    {label}{' '}
                    {isRequired ? <span className="color">*</span> : null}
                </label>
            ) : null}

            <textarea
                {...input}
                {...custome}
                readOnly={readOnly}
                onChange={(e) => input.onChange(e)}
            ></textarea>

            {touched &&
                ((error && (
                    <small className="text-danger text-validate">{error}</small>
                )) ||
                    (warning && (
                        <small className="text-warning text-validate">
                            {warning}
                        </small>
                    )))}
        </>
    );
};
TextAreaField.propTypes = propTypes;

export default TextAreaField;
